import type { RemoveManyFromCartPayload } from '@model/Cart.model';
import { CART_REMOVE_ITEMS } from './CartActionTypes';

export const removeManyFromCartAction = (payload: RemoveManyFromCartPayload) => (dispatch: any) => {
  dispatch({ type: CART_REMOVE_ITEMS, payload });
};
